import { render, staticRenderFns } from "./bxDcConf.vue?vue&type=template&id=1f3651c6&scoped=true&"
import script from "./bxDcConf.vue?vue&type=script&lang=js&"
export * from "./bxDcConf.vue?vue&type=script&lang=js&"
import style0 from "./bxDcConf.vue?vue&type=style&index=0&id=1f3651c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3651c6",
  null
  
)

export default component.exports